import React from 'react';
import { NavLink } from 'react-router-dom';
import { ROLES_KEY } from '../../login/constants';
import history from '../../../common/history';
import { loginUrl, navMenus } from './navigation-bar-constants';

const Navigation = ({ className = null }) => {
  const getUserRoleBasedNavMenu = () => {
    const userRolesInString = localStorage.getItem(ROLES_KEY);
    if (userRolesInString) {
      const userRoles = userRolesInString.split(',');
      return navMenus.filter(menu => {
        return userRoles.some(role => menu.roles.includes(role));
      });
    } else {
      history.push(loginUrl);
      return navMenus;
    }
  };

  return (
    <ul className={className ? className : ''}>
      <NavLink to="/dashboard" exact={true} activeClassName="active">
        <li>
          <img src={`/images/icons/navigation_bar/home.svg`}
               alt="Home"
               className="side-nav-icon-image"
          />
          <p>Home</p>
        </li>
      </NavLink>
      {getUserRoleBasedNavMenu().map((i, index) => (
        <NavLink to={`${i.path}`} activeClassName="active" key={index}>
          <li>
            {i.icon ? (
              <i className={`la la-${i.icon}`}></i>
            ) : (
              <img src={`/images/icons/navigation_bar/${i.iconImage}`}
                   alt={`${i.iconImageAltText}`}
                   className="side-nav-icon-image"
              />
            )}
            <p>{i.name}</p>
          </li>
        </NavLink>
      ))}
    </ul>
  );
};

function NavigationBar(props) {
  return (
    <aside>
      <div className="side-nav-container">
        <nav>
          <div className="menuToggle">
            <input type="checkbox" />
            <span></span>
            <span></span>
            <span></span>
            <Navigation className="menu" />
          </div>
        </nav>
        <div className="side-navigation">
          <Navigation />
        </div>
      </div>
    </aside>
  );
}
export default NavigationBar;



// WEBPACK FOOTER //
// ./src/features/shared-components/navigation-bar/navigation-bar.js